import React from 'react';
import { View } from 'react-native';
import { ListItem } from '../../Core/List/ListItem';
import { Text } from '../../Core/Text/Text';
import { Typography } from '../../Core/Typography/Typography';
import { FlagIcon } from '../../Icons/FlagIcon';
import { IconProps } from '../../Icons/Icons.types';
import { cn } from '../../lib/utils';

export type BalanceText = {
  primary?: string;
  secondary?: string;
};

export type CurrencyListItemType = {
  iconComponent?: React.ElementType;
  iconProps?: IconProps;
  subtitle: string;
  infoText?: string;
  title: string;
  onPress: () => void;
  balanceText?: BalanceText;
  active?: boolean;
  error?: boolean;
  className?: string;
};

export const CurrencyListItem = ({
  iconComponent: IconComponent,
  title,
  subtitle,
  active = true,
  error = false,
  infoText,
  onPress,
  iconProps,
  balanceText,
  className,
}: CurrencyListItemType) => {
  const disabledStyle = !active && 'opacity-30';
  const largeTextColor = error ? 'text-error' : 'text-white';
  const smallTextColor = error ? 'text-error' : 'text-neutral-300';

  return (
    <ListItem onPress={onPress} pressable={active} className={className}>
      <View className="w-full">
        <View className="flex-row">
          {IconComponent ? (
            <View className="mr-4 justify-center">
              <IconComponent {...iconProps} width={30} />
            </View>
          ) : (
            <View className="mr-4 justify-center">
              <FlagIcon className="" width={30} />
            </View>
          )}
          <View className="flex-1 flex-column justify-center">
            <Typography
              variant="callToAction"
              className={cn('text-white', disabledStyle)}>
              {title}
            </Typography>
            <Typography
              size="small"
              className={cn('text-neutral-300', disabledStyle)}>
              {subtitle}
            </Typography>
          </View>

          <View className="flex-column justify-center items-end">
            <Typography
              variant="callToAction"
              className={cn(largeTextColor, disabledStyle)}>
              {balanceText?.primary}
            </Typography>
            {balanceText?.secondary && (
              <Typography
                size="small"
                className={cn(largeTextColor, disabledStyle)}>
                {balanceText?.secondary}
              </Typography>
            )}
          </View>
        </View>
        {infoText && (
          // TODO: check if this font size is really correct/needed and if yes add it to the style guide and tailwind
          <Text
            className={cn('mt-2', smallTextColor, disabledStyle)}
            style={{ fontSize: 11, lineHeight: 13 }}>
            {infoText}
          </Text>
        )}
      </View>
    </ListItem>
  );
};
